// CON-2034 — where the one Short codes row sits in the Connections list.
// The server orders chats by tier (pinned 0; a received or hand-sent text 1;
// automated sends only 2), then by that tier's sort time, newest first, and
// sends both with each chat (listTier, listSortTime). The row is short-code
// texts received, so it goes where a tier 1 chat with its latest text's time
// would: below pinned chats, above automated-only ones. While that is below
// every chat loaded so far and more pages exist, the row is left out; it
// appears once paging reaches its place. With the list fully loaded it goes
// last. Same rule as the Chat app (helpers/shortCodes.ts).

const toTime = (value) => {
  if (!value) return null;
  const time = new Date(value).getTime();
  return Number.isNaN(time) ? null : time;
};

// The time a chat row shows: received for a received text, sent for a sent
// one, then the other stamps (same order as the Chat app's chat row).
export const chatLastMessageTime = (chat) => {
  const last = chat?.messages?.at(-1);
  return toTime(chat?.socketDateReceived)
    ?? toTime(last?.isReceived ? last?.receivedAt : last?.sentAt)
    ?? toTime(last?.scheduledAt)
    ?? toTime(last?.receivedAt)
    ?? toTime(last?.sentAt)
    ?? toTime(last?.createdAt);
};

// A chat's place in the server's order. A text received since the list
// loaded (socketDateReceived, which the list sorts to the top) makes it tier 1
// at that time. Without listTier, falls back to the displayed time.
export const chatOrderEntry = (chat, isPinned) => {
  const socketTime = toTime(chat?.socketDateReceived);
  if (chat?.listTier !== null && chat?.listTier !== undefined) {
    if (socketTime && chat.listTier !== 0) {
      return { isPinned, tier: 1, time: socketTime };
    }
    return { isPinned, tier: chat.listTier, time: toTime(chat.listSortTime) };
  }
  return { isPinned, tier: null, time: chatLastMessageTime(chat) };
};

// entries: the chats in display order, [{ isPinned, tier, time }] (tier null
// = not sent by the server, time = the displayed time). Returns the index
// the row goes before, or -1 to leave it out for now.
export const shortCodesRowIndex = (entries = [], latestReceivedAt = null, hasMore = false) => {
  const latest = toTime(latestReceivedAt);
  if (latest === null) return hasMore ? -1 : entries.length;

  const index = entries.findIndex((entry) => {
    if (entry.isPinned || entry.tier === 0) return false;
    if (entry.tier !== null && entry.tier >= 2) return true;
    return entry.time === null || entry.time < latest;
  });
  if (index !== -1) return index;
  return hasMore ? -1 : entries.length;
};
